
interface SourceCitationProps {
  text: string;
  url: string;
}

const SourceCitation = ({ text, url }: SourceCitationProps) => {
  return (
    <div className="mt-auto pt-4 border-t border-white/10">
      <span className="text-xs text-primary/80">
        Source:{' '}
        <a 
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-primary transition-colors"
        >
          {text}
        </a>
      </span>
    </div>
  );
};

export default SourceCitation;
